<script>
    import Sidebar from "./Sidebar/Sidebar.svelte";
    import { Route } from "svelte-router-spa";

    export let currentRoute;
    export let params;
</script>

<div id="wrapper">
    <Sidebar />
    <div id="contenido">
        <Route {currentRoute} {params} />
    </div>
</div>